import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	buttonLabel: {
		id: 'software-view-settings.view-settings-button.button-label',
		defaultMessage: 'View settings',
		description: "A settings menu for a board's view settings",
	},
});
